import {
  Box,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import YouTube from "react-youtube";
import { closeExamHintkModel } from "../../../modules/admin-modules/models/Actions";
import { extractYouTubeVideoId } from "../../../utils/youtubeVideoId";

const ExamHint = ({ videoId, model_answer_image }) => {
  const isOpen = useSelector((state) => state.model.isOpen30);
  const dispatch = useDispatch();
  const baseUrl = "https://edutopiaonline.com/api";

  const resolvedVideoId = useMemo(() => {
    if (videoId == null || videoId === "") return null;
    const s = String(videoId).trim();
    return extractYouTubeVideoId(s) || (/^[a-zA-Z0-9_-]{11}$/.test(s) ? s : null);
  }, [videoId]);

  const opts = {
    height: 360,
    width: 640,
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
      rel: 0,
    },
  };
  const onReady = (event) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };
  const handelClose = () => {
    dispatch(closeExamHintkModel());
  };
  return (
    <Modal
      isCentered
      onClose={handelClose}
      isOpen={isOpen}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent maxW={{ base: "calc(100vw - 24px)", md: "xl" }}>
        <ModalCloseButton />
        <ModalBody
          p={4}
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          gap={4}
        >
          <>
            {model_answer_image && model_answer_image !== "null" && model_answer_image !== "undefined" && (
              <Image
                src={`${baseUrl}/${model_answer_image}`}
                w="100%"
                maxW={{ base: "100%", md: "320px" }}
                maxH={{ base: "240px", md: "240px" }}
                objectFit="contain"
                borderRadius="md"
              />
            )}
            {resolvedVideoId ? (
              <Box
                w="100%"
                maxW="640px"
                mx="auto"
                sx={{
                  "& iframe": {
                    display: "block",
                    maxWidth: "100%",
                  },
                }}
              >
                <YouTube videoId={resolvedVideoId} opts={opts} onReady={onReady} />
              </Box>
            ) : null}
          </>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ExamHint;
